export default "__VITE_ASSET__61VsD4_T__"